const getDefaultState = () => ({
  isLoading: false,
  cycle: 'MONTHLY',
  totalPrice: 0,
  selectedPlan: null,
  paymentMethod: null,
  coupon: null,
  paymentCode: null,
  creditCardInfo: null,
  plans: []
});

const state = getDefaultState();

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  cycle(state) {
    return state.cycle;
  },
  selectedPlan(state) {
    return state.selectedPlan;
  },
  paymentMethod(state) {
    return state.paymentMethod;
  },
  coupon(state) {
    return state.coupon;
  },
  creditCardInfo(state) {
    return state.creditCardInfo;
  },
  plans(state) {
    return state.plans;
  },
  totalPrice(state) {
    return state.totalPrice;
  },
  paymentCode(state) {
    return state.paymentCode;
  }
};

const mutations = {
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_CYCLE(state, cycle) {
    state.cycle = cycle;
  },
  SET_SELECTED_PLAN(state, payload) {
    if (payload === null) {
      state.selectedPlan = null;
      return;
    }
    state.selectedPlan = payload;
  },
  SET_PAYMENT_METHOD(state, payload) {
    state.paymentMethod = payload;
  },
  SET_COUPON(state, payload) {
    state.coupon = payload;
  },
  SET_CREDIT_CARD_INFO(state, payload) {
    state.creditCardInfo = payload;
  },
  SET_PLANS(state, payload) {
    state.plans = payload;
  },
  SET_PAYMENT_CODE(state, payload) {
    state.paymentCode = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  CALCULATE_TOTAL_PRICE(state) {
    const { coupon } = state;

    let planPrice = coupon?.signature_price?.price || state.selectedPlan.price;

    if (coupon?.recurrency === 'MONTHLY') {
      if (coupon.discount_type === 'percentage') {
        planPrice -= planPrice * (coupon.discount_value / 100);
      } else if (coupon.discount_type === 'value') {
        planPrice -= coupon.discount_value;
      }
    }

    const discount = state.cycle === 'YEARLY' ? coupon?.signature_price?.annual_discount || state.selectedPlan?.annual_discount : 0;
    const fullPrice = state.cycle === 'YEARLY' ? planPrice * 12 : planPrice;
    let discountCoupon = 0;

    if (coupon?.recurrency === 'UNIQUE') {
      if (coupon.discount_type === 'percentage') {
        discountCoupon = fullPrice * (coupon.discount_value / 100);
      } else if (coupon.discount_type === 'value') {
        discountCoupon = coupon.discount_value;
      }
    }

    const totalPrice = fullPrice - discount - discountCoupon;

    state.totalPrice = totalPrice <= 0 ? 0 : totalPrice;
    state.paymentCode = null;
  }
};

const actions = {
  resetState({ commit }) {
    commit('RESET_STATE');
  },
  setLoading({ commit }, status) {
    commit('SET_LOADING', status);
  },
  setPlans({ commit }, plans) {
    commit('SET_PLANS', plans);
  },
  setSelectedPlan({ commit }, selectedPlan) {
    commit('SET_SELECTED_PLAN', selectedPlan);
    commit('CALCULATE_TOTAL_PRICE');
  },
  setCoupon({ commit }, coupon) {
    commit('SET_COUPON', coupon);
    commit('CALCULATE_TOTAL_PRICE');
  },
  setCycle({ commit }, cycle) {
    commit('SET_CYCLE', cycle);
    commit('CALCULATE_TOTAL_PRICE');
  },
  setPaymentMethod({ commit }, paymentMethod) {
    commit('SET_PAYMENT_METHOD', paymentMethod);
    commit('CALCULATE_TOTAL_PRICE');
  },
  setCreditCardInfo({ commit }, creditCardInfo) {
    commit('SET_CREDIT_CARD_INFO', creditCardInfo);
  },
  setPaymentCode({ commit }, paymentCode) {
    commit('SET_PAYMENT_CODE', paymentCode);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
